import React from 'react';
import { Redirect } from 'react-router-dom';
import { useCurrentUser } from '../../hooks/useCurrentUser';

/**
 * Role guard component.
 * - If user doesn't have required role: redirectTo prop is used (default: show 403 message).
 * - Backend always enforces — this is purely UX.
 *
 * @param {{ roles: string[], redirectTo?: string, fallback?: React.ReactNode, children: React.ReactNode }} props
 */
export function RequireRole({ roles, redirectTo, fallback, children }) {
  const user = useCurrentUser();

  // Still loading
  if (user === null) return null;

  const hasRole = roles.some(r => {
    if (r === 'manager') return user.isManager;
    if (r === 'admin') return user.isManager;
    if (r === 'root') return user.isRoot;
    return user.role === r;
  });

  if (!hasRole) {
    if (redirectTo) return <Redirect to={redirectTo} />;
    if (fallback) return <>{fallback}</>;
    return (
      <div style={{ padding: '2rem', textAlign: 'center', color: '#7f8c8d' }}>
        <div style={{ fontSize: '3rem' }}>🔒</div>
        <p style={{ fontSize: '1.1rem', marginTop: '1rem' }}>
          Acesso restrito. Você não tem permissão para visualizar esta seção.
        </p>
      </div>
    );
  }

  return <>{children}</>;
}

export default RequireRole;
